// extracted by mini-css-extract-plugin
export default {"ldsRing":"spinner_ldsRing__3rskS","lds-ring":"spinner_lds-ring__-osRK","ldsRing-ring":"spinner_ldsRing-ring__aqgrb"};